export interface UpdateProductionProcessesSupplier {
  productionProcessId: string;
  default: boolean;
}
